var
    // Tooltip settings
    settings = {
        svgNamespace: "http://www.w3.org/2000/svg",

        // Minimum space from the viewport's edge when no explicit viewport is provided
        defaultViewportMargin: 10,

        // Size of the triangular notch
        notchSize: 10,

        // This moves the position of the tooltip closer or further away from the target;
        // set to the opposite of the drop shadow size to make the notch touch the target's edge
        spacingAdjustment: 0,

        // Outline settings
        outline: {
            color: "#f58345",
            opacity: 1,
            radius: 10
        },

        // Drop shadow settings
        dropShadow: {
            color: "#333333",
            opacity: 0.25,
            size: 5,
            xOffset: 2,
            yOffset: 2
        },

        // Animation settings
        revealDuration: 0.5,
        revealDistance: -5,
        hideDuration: 0.3,
        slowMoScale: 5,

        // Class names
        classNames: {
            base: "tooltip",

            positioningTypeAbove: "tooltip-above",
            positioningTypeBelow: "tooltip-below",
            positioningTypeLeft: "tooltip-left",
            positioningTypeRight: "tooltip-right"
        }
    },

    positioningTypes = {
        above: 0,
        below: 1,
        left: 2,
        right: 3
    },

    filterCount = 0,

    numberToPx = function (value) {
        return value.toString() + "px";
    };

export class Tooltip {
    constructor(hoverElement, targetElement, tooltipContent, positioningType, viewport) {
        var t = this;

        t.visible = false;
        t.originalPositioningType = positioningType;

        // Setup viewport if not specified
        if (typeof viewport != "object" || viewport === null) {
            viewport = {};

            var resizeCallback = function () {
                viewport.top = settings.defaultViewportMargin;
                viewport.bottom = viewport.top + window.innerHeight - (settings.defaultViewportMargin * 2);

                viewport.left = settings.defaultViewportMargin;
                viewport.right = viewport.left + window.innerWidth - (settings.defaultViewportMargin * 2);
            };

            window.addEventListener("resize", resizeCallback);
            resizeCallback();
        }

        // Create our DOM elements
        t.container = document.createElement("div");
        t.container.classList.add(settings.classNames.base);

        t.svg = document.createElementNS(settings.svgNamespace, "svg");
        t.container.appendChild(t.svg);

        t.content = document.createElement("div");
        t.content.innerHTML = tooltipContent;
        t.container.appendChild(t.content);

        // Construct the entire SVG template programmatically... I tried some
        // shortcuts to avoid this, but browsers were having none of it
        var filterId = "tooltip-dropshadow-" + (++filterCount).toString(),
            defsNode = document.createElementNS(settings.svgNamespace, "defs"),
            filterNode = document.createElementNS(settings.svgNamespace, "filter"),
            feMorphologyNode = document.createElementNS(settings.svgNamespace, "feMorphology"),
            feOutlineFloodNode = document.createElementNS(settings.svgNamespace, "feFlood"),
            feOutlineCompositeNode = document.createElementNS(settings.svgNamespace, "feComposite"),
            feGaussianBlurNode = document.createElementNS(settings.svgNamespace, "feGaussianBlur"),
            feOffsetNode = document.createElementNS(settings.svgNamespace, "feOffset"),
            feBlurFloodNode = document.createElementNS(settings.svgNamespace, "feFlood"),
            feBlurCompositeNode = document.createElementNS(settings.svgNamespace, "feComposite"),
            feMergeNode = document.createElementNS(settings.svgNamespace, "feMerge"),
            feMergeNodeNode = document.createElementNS(settings.svgNamespace, "feMergeNode"),
            outerGroupNode = document.createElementNS(settings.svgNamespace, "g"),
            polygonGroupNode = document.createElementNS(settings.svgNamespace, "g"),
            polygonNode = document.createElementNS(settings.svgNamespace, "polygon"),
            textGroupNode = document.createElementNS(settings.svgNamespace, "g"),
            backdropNode;

        // If there's a corner radius specified for the tooltip, we'll generate a
        // path for the backdrop; otherwise we just make a rect
        if (settings.outline.radius > 0)
            backdropNode = document.createElementNS(settings.svgNamespace, "path");
        else
            backdropNode = document.createElementNS(settings.svgNamespace, "rect");

        // Create defs node to contain the filter
        t.svg.appendChild(defsNode);

        // Create filter node to contain the instructions
        filterNode.setAttribute("id", filterId);
        defsNode.appendChild(filterNode);

        // Apply outline effect
        feMorphologyNode.setAttribute("operator", "dilate");
        feMorphologyNode.setAttribute("in", "SourceAlpha");
        feMorphologyNode.setAttribute("result", "dilated");
        feMorphologyNode.setAttribute("radius", "1");
        filterNode.appendChild(feMorphologyNode);

        // Change the outline's color
        feOutlineFloodNode.setAttribute("flood-color", settings.outline.color);
        feOutlineFloodNode.setAttribute("flood-opacity", settings.outline.opacity.toString());
        feOutlineFloodNode.setAttribute("result", "colorized1");
        filterNode.appendChild(feOutlineFloodNode);

        // Composite the color with the outline
        feOutlineCompositeNode.setAttribute("in", "colorized1");
        feOutlineCompositeNode.setAttribute("in2", "dilated");
        feOutlineCompositeNode.setAttribute("operator", "in");
        feOutlineCompositeNode.setAttribute("result", "outline");
        filterNode.appendChild(feOutlineCompositeNode);

        // Apply gaussian blur, overwriting the outline - we leave this on screen
        feGaussianBlurNode.setAttribute("in", "SourceAlpha");
        feGaussianBlurNode.setAttribute("stdDeviation", (settings.dropShadow.size / 2).toString());
        filterNode.appendChild(feGaussianBlurNode);

        // Offset gaussian blur
        feOffsetNode.setAttribute("dx", settings.dropShadow.xOffset.toString());
        feOffsetNode.setAttribute("dy", settings.dropShadow.yOffset.toString());
        feOffsetNode.setAttribute("result", "offsetblur");
        filterNode.appendChild(feOffsetNode);

        // Change the blur's color
        feBlurFloodNode.setAttribute("flood-color", settings.dropShadow.color);
        feBlurFloodNode.setAttribute("flood-opacity", settings.dropShadow.opacity.toString());
        feBlurFloodNode.setAttribute("result", "colorized2");
        filterNode.appendChild(feBlurFloodNode);

        // Composite the color with the blur
        feBlurCompositeNode.setAttribute("in", "colorized2");
        feBlurCompositeNode.setAttribute("in2", "offsetblur");
        feBlurCompositeNode.setAttribute("operator", "in");
        feBlurCompositeNode.setAttribute("result", "colorblur");
        filterNode.appendChild(feBlurCompositeNode);

        // Add merge node
        filterNode.appendChild(feMergeNode);

        // An empty merge node includes what's currently on screen (...I think)
        feMergeNode.appendChild(document.createElementNS(settings.svgNamespace, "feMergeNode"));

        // Merge in the "outline" result
        feMergeNodeNode.setAttribute("in", "outline");
        feMergeNode.appendChild(feMergeNodeNode);

        // Merge in the original source graphic
        feMergeNodeNode = document.createElementNS(settings.svgNamespace, "feMergeNode");
        feMergeNodeNode.setAttribute("in", "SourceGraphic");
        feMergeNode.appendChild(feMergeNodeNode);

        // Apply the filter to the group that includes all our shapes
        outerGroupNode.setAttribute("style", "filter: url(#" + filterId + ")");
        t.svg.appendChild(outerGroupNode);

        outerGroupNode.appendChild(polygonGroupNode);

        polygonGroupNode.appendChild(polygonNode);

        outerGroupNode.appendChild(textGroupNode);

        textGroupNode.appendChild(backdropNode);

        // Add our elements to the body
        document.body.appendChild(t.container);
        t.container.style.width = "100%";

        // Measure text and adjust positioning of the SVG rect
        // and our content div to accomodate for the drop shadow size
        var
            dimensions = {
                margins: {
                    top: settings.dropShadow.size,
                    right: settings.dropShadow.size + settings.dropShadow.xOffset,
                    bottom: settings.dropShadow.size + settings.dropShadow.yOffset,
                    left: settings.dropShadow.size
                },
                textBox: {
                    x: settings.dropShadow.size,
                    y: settings.dropShadow.size,
                    width: t.content.clientWidth,
                    height: t.content.clientHeight
                }
            },
            tooltipSizeWithoutNotch = {
                width: dimensions.textBox.width + dimensions.margins.left + dimensions.margins.right,
                height: dimensions.textBox.height + dimensions.margins.top + dimensions.margins.bottom
            };

        t.container.removeAttribute("style");

        // Hide everything
        t.container.style.display = "none";

        // Setup mouseover & touch events
        var
            timeline = null,

            revealCallback = function (event) {
                t.visible = true;

                t.container.style.display = "block";

                // Reset positioning type
                positioningType = t.originalPositioningType;

                // Determine how the tooltip should be positioned, in its primary
                // presentation axis, given the requested positioningType value
                // (left/right = x axis, above/below = y axis)
                var
                    containerOffset = null,
                    textBoxPositionWithNotch = null,
                    tooltipSizeWithNotch = null,
                    targetBoundingBox = targetElement.getBoundingClientRect();

                switch (positioningType) {
                    case positioningTypes.above:
                        // Set tooltipSizeWithNotch value
                        tooltipSizeWithNotch = {
                            width: tooltipSizeWithoutNotch.width,
                            height: tooltipSizeWithoutNotch.height + settings.notchSize
                        };

                        // Determine if there's no room above the target element
                        // to fit the tooltip on screen
                        var
                            containerBoundingBoxTop = (targetBoundingBox.top - settings.spacingAdjustment) - tooltipSizeWithNotch.height,
                            containerBoundingBoxBottom = containerBoundingBoxTop + tooltipSizeWithNotch.height;

                        if (containerBoundingBoxTop < viewport.top) {
                            // There's no room above - check below
                            containerBoundingBoxTop = (targetBoundingBox.top + settings.spacingAdjustment) + targetBoundingBox.height;
                            containerBoundingBoxBottom = containerBoundingBoxTop + tooltipSizeWithNotch.height;

                            if (containerBoundingBoxBottom < viewport.bottom) {
                                // There's room below - switch to that positioning
                                containerOffset = {
                                    top: (targetBoundingBox.top + settings.spacingAdjustment) + targetBoundingBox.height,
                                    left: targetBoundingBox.left
                                };

                                positioningType = positioningTypes.below;

                                // Set textBoxPositionWithNotch value based on below positioning
                                textBoxPositionWithNotch = {
                                    x: dimensions.textBox.x,
                                    y: dimensions.textBox.y + settings.notchSize
                                };
                            }
                        }

                        // If we didn't choose an alternate positioning, go with the default position
                        if (containerOffset == null) {
                            containerOffset = {
                                top: (targetBoundingBox.top - settings.spacingAdjustment) - tooltipSizeWithNotch.height,
                                left: targetBoundingBox.left
                            };

                            // Set textBoxPositionWithNotch value based on above positioning
                            textBoxPositionWithNotch = {
                                x: dimensions.textBox.x,
                                y: dimensions.textBox.y
                            };
                        }
                        break;

                    case positioningTypes.below:
                        // Set tooltipSizeWithNotch value
                        tooltipSizeWithNotch = {
                            width: tooltipSizeWithoutNotch.width,
                            height: tooltipSizeWithoutNotch.height + settings.notchSize
                        };

                        // Determine if there's no room below of the target element
                        // to fit the tooltip on screen
                        var
                            containerBoundingBoxTop = (targetBoundingBox.top + settings.spacingAdjustment) + targetBoundingBox.height,
                            containerBoundingBoxBottom = containerBoundingBoxTop + tooltipSizeWithNotch.height;

                        if (containerBoundingBoxBottom > viewport.bottom) {
                            // There's no room below - check above
                            containerBoundingBoxTop = (targetBoundingBox.top - settings.spacingAdjustment) - tooltipSizeWithNotch.height;

                            if (containerBoundingBoxTop > viewport.top) {
                                // There's room above - switch to that positioning
                                containerOffset = {
                                    top: (targetBoundingBox.top - settings.spacingAdjustment) - tooltipSizeWithNotch.height,
                                    left: targetBoundingBox.left
                                };

                                positioningType = positioningTypes.above;

                                // Set textBoxPositionWithNotch value based on above positioning
                                textBoxPositionWithNotch = {
                                    x: dimensions.textBox.x,
                                    y: dimensions.textBox.y
                                };
                            }
                        }

                        // If we didn't choose an alternate positioning, go with the default position
                        if (containerOffset == null) {
                            containerOffset = {
                                top: (targetBoundingBox.top + settings.spacingAdjustment) + targetBoundingBox.height,
                                left: targetBoundingBox.left
                            };

                            // Set textBoxPositionWithNotch value based on below positioning
                            textBoxPositionWithNotch = {
                                x: dimensions.textBox.x,
                                y: dimensions.textBox.y + settings.notchSize
                            };
                        }
                        break;

                    case positioningTypes.left:
                        // Set tooltipSizeWithNotch value
                        tooltipSizeWithNotch = {
                            width: tooltipSizeWithoutNotch.width + settings.notchSize,
                            height: tooltipSizeWithoutNotch.height
                        };

                        // Determine if there's no room to the left of the target element
                        // to fit the tooltip on screen
                        var
                            containerBoundingBoxLeft = (targetBoundingBox.left - settings.spacingAdjustment) - tooltipSizeWithNotch.width,
                            containerBoundingBoxRight = containerBoundingBoxLeft + tooltipSizeWithNotch.width;

                        if (containerBoundingBoxLeft < viewport.left) {
                            // There's no room on the left - check on the right
                            containerBoundingBoxLeft = (targetBoundingBox.left + settings.spacingAdjustment) + targetBoundingBox.width;
                            containerBoundingBoxRight = containerBoundingBoxLeft + tooltipSizeWithNotch.width;

                            if (containerBoundingBoxRight < viewport.right) {
                                // There's room on the right - switch to that positioning
                                containerOffset = {
                                    top: targetBoundingBox.top,
                                    left: (targetBoundingBox.left + settings.spacingAdjustment) + targetBoundingBox.width
                                };

                                positioningType = positioningTypes.right;

                                // Set textBoxPositionWithNotch value based on right positioning
                                textBoxPositionWithNotch = {
                                    x: dimensions.textBox.x + settings.notchSize,
                                    y: dimensions.textBox.y
                                };
                            }
                        }

                        // If we didn't choose an alternate positioning, go with the default position
                        if (containerOffset == null) {
                            containerOffset = {
                                top: targetBoundingBox.top,
                                left: (targetBoundingBox.left - settings.spacingAdjustment) - tooltipSizeWithNotch.width
                            };

                            // Set textBoxPositionWithNotch value based on left positioning
                            textBoxPositionWithNotch = {
                                x: dimensions.textBox.x,
                                y: dimensions.textBox.y
                            };
                        }
                        break;

                    case positioningTypes.right:
                        // Set tooltipSizeWithNotch value
                        tooltipSizeWithNotch = {
                            width: tooltipSizeWithoutNotch.width + settings.notchSize,
                            height: tooltipSizeWithoutNotch.height
                        };

                        // Determine if there's no room to the right of the target element
                        // to fit the tooltip on screen
                        var
                            containerBoundingBoxLeft = (targetBoundingBox.left + settings.spacingAdjustment) + targetBoundingBox.width,
                            containerBoundingBoxRight = containerBoundingBoxLeft + tooltipSizeWithNotch.width;

                        if (containerBoundingBoxRight > viewport.right) {
                            // There's no room on the right - check on the left
                            containerBoundingBoxLeft = (targetBoundingBox.left - settings.spacingAdjustment) - tooltipSizeWithNotch.width;

                            if (containerBoundingBoxLeft > viewport.left) {
                                // There's room on the left - switch to that positioning
                                containerOffset = {
                                    top: targetBoundingBox.top,
                                    left: (targetBoundingBox.left - settings.spacingAdjustment) - tooltipSizeWithNotch.width
                                };

                                positioningType = positioningTypes.left;

                                // Set textBoxPositionWithNotch value based on left positioning
                                textBoxPositionWithNotch = {
                                    x: dimensions.textBox.x,
                                    y: dimensions.textBox.y
                                };
                            }
                        }

                        // If we didn't choose an alternate positioning, go with the default position
                        if (containerOffset == null) {
                            containerOffset = {
                                top: targetBoundingBox.top,
                                left: (targetBoundingBox.left + settings.spacingAdjustment) + targetBoundingBox.width
                            };

                            // Set textBoxPositionWithNotch value based on right positioning
                            textBoxPositionWithNotch = {
                                x: dimensions.textBox.x + settings.notchSize,
                                y: dimensions.textBox.y
                            };
                        }
                        break;
                }

                // Determine how the tooltip should be positioned in its secondary axis
                // NOTE: this is where we should add detection for the primary axis edges overflowing the viewport
                // and offset the positioning accordingly... someday
                var notchPositioningOffset = 0;
                if (positioningType == positioningTypes.above || positioningType == positioningTypes.below) {
                    // X axis
                    var
                        containerBoundingBoxLeft = containerOffset.left + ((targetBoundingBox.width - dimensions.textBox.width) / 2) - settings.dropShadow.size,
                        containerBoundingBoxRight = containerBoundingBoxLeft + dimensions.textBox.width;

                    // Determine if there's no room to fit the tooltip on screen in this axis
                    if (containerBoundingBoxLeft + settings.dropShadow.size < viewport.left) {
                        // There's no room on the left - check if there's room on the right
                        if ((viewport.left + dimensions.textBox.width) < viewport.right) {
                            // There's room on the right - offset the positioning
                            notchPositioningOffset = containerBoundingBoxLeft + settings.dropShadow.size - viewport.left;
                            containerBoundingBoxLeft = viewport.left - settings.dropShadow.size;
                        }
                    } else if (containerBoundingBoxRight + settings.dropShadow.size > viewport.right) {
                        // There's no room on the right - check if there's room on the left
                        if ((viewport.right - dimensions.textBox.width) > viewport.left) {
                            // There's room on the left - offset the positioning
                            notchPositioningOffset = containerBoundingBoxRight + settings.dropShadow.size - viewport.right;
                            containerBoundingBoxLeft = viewport.right - (dimensions.textBox.width + settings.dropShadow.size);
                        }
                    }

                    containerOffset.left = containerBoundingBoxLeft;
                } else {
                    // Y axis
                    var
                        containerBoundingBoxTop = containerOffset.top + ((targetBoundingBox.height - dimensions.textBox.height) / 2) - settings.dropShadow.size,
                        containerBoundingBoxBottom = containerBoundingBoxTop + dimensions.textBox.height;

                    // Determine if there's no room to fit the tooltip on screen in this axis
                    if (containerBoundingBoxTop + settings.dropShadow.size < viewport.top) {
                        // There's no room above - check if there's room below
                        if ((viewport.top + dimensions.textBox.height) < viewport.bottom) {
                            // There's room below - offset the positioning
                            notchPositioningOffset = containerBoundingBoxTop + settings.dropShadow.size - viewport.top;
                            containerBoundingBoxTop = viewport.top - settings.dropShadow.size;
                        }
                    } else if (containerBoundingBoxBottom + settings.dropShadow.size > viewport.bottom) {
                        // There's no room below - check if there's room above
                        if ((viewport.bottom - dimensions.textBox.height) > viewport.top) {
                            // There's room above - offset the positioning
                            notchPositioningOffset = containerBoundingBoxBottom + settings.dropShadow.size - viewport.bottom;
                            containerBoundingBoxTop = viewport.bottom - (dimensions.textBox.height + settings.dropShadow.size);
                        }
                    }

                    containerOffset.top = containerBoundingBoxTop;
                }

                // Set the container positioning
                t.container.style.top = numberToPx(containerOffset.top);
                t.container.style.left = numberToPx(containerOffset.left);

                // Set the dimensions of our container element & SVG
                t.svg.style.width = numberToPx(Math.ceil(tooltipSizeWithNotch.width));
                t.svg.style.height = numberToPx(Math.ceil(tooltipSizeWithNotch.height));

                t.container.style.width = numberToPx(Math.ceil(tooltipSizeWithNotch.width));
                t.container.style.height = numberToPx(Math.ceil(tooltipSizeWithNotch.height));

                // Set the scale of the filter - by default, it's limited to the size of the
                // content it's applied to and will end up clipped
                // NOTE: the commented out lines work in desktop browsers but not in iOS, so I'm
                // hacking it a bit here...
                //filterNode.setAttribute("width", Math.ceil(tooltipSizeWithNotch.width).toString());
                //filterNode.setAttribute("height", Math.ceil(tooltipSizeWithNotch.height).toString());
                filterNode.setAttribute("width", "200%");
                filterNode.setAttribute("height", "200%");

                // Set the positioning & dimensions of our content div
                t.content.style.left = numberToPx(textBoxPositionWithNotch.x);
                t.content.style.top = numberToPx(textBoxPositionWithNotch.y);

                // Construct the backdrop polygon, if necessary; otherwise just set
                // its dimensions
                if (settings.outline.radius > 0) {
                    var
                        backdropPolygonPoints = `M${textBoxPositionWithNotch.x + settings.outline.radius} ${textBoxPositionWithNotch.y}`,
                        doubleRadius = settings.outline.radius + settings.outline.radius,
                        shortWidth = dimensions.textBox.width - doubleRadius,
                        shortHeight = dimensions.textBox.height - doubleRadius;

                    backdropPolygonPoints += ` h ${shortWidth}`;
                    backdropPolygonPoints += ` q ${settings.outline.radius} ${0} ${settings.outline.radius} ${settings.outline.radius}`;
                    backdropPolygonPoints += ` v ${shortHeight}`;
                    backdropPolygonPoints += ` q ${0} ${settings.outline.radius} ${-settings.outline.radius} ${settings.outline.radius}`;
                    backdropPolygonPoints += ` h ${-shortWidth}`;
                    backdropPolygonPoints += ` q ${-settings.outline.radius} ${0} ${-settings.outline.radius} ${-settings.outline.radius}`;
                    backdropPolygonPoints += ` v ${-shortHeight}`;
                    backdropPolygonPoints += ` q ${0} ${-settings.outline.radius} ${settings.outline.radius} ${-settings.outline.radius}`;
                    backdropPolygonPoints += " Z";

                    backdropNode.setAttribute("d", backdropPolygonPoints);
                } else {
                    backdropNode.setAttribute("x", textBoxPositionWithNotch.x.toString());
                    backdropNode.setAttribute("y", textBoxPositionWithNotch.y.toString());
                    backdropNode.setAttribute("width", dimensions.textBox.width.toString());
                    backdropNode.setAttribute("height", dimensions.textBox.height.toString());
                }

                // Set container base class
                t.container.removeAttribute("class");
                t.container.classList.add(settings.classNames.base);

                // Create the notch polygon and set container positioning class
                // Note: all the "+ 1"s and "- 1"s are to provide a slight overlap between the notch
                // and the backdrop; some browsers render a slight space artifact between them if their
                // edges are at the exact same position, particularly when zoomed in
                var notchPolygonPoints = "";
                switch (positioningType) {
                    case positioningTypes.above:
                        var polygonMidpoint = ((tooltipSizeWithNotch.width - settings.dropShadow.xOffset) / 2) + notchPositioningOffset;
                        if (polygonMidpoint < settings.dropShadow.size)
                            polygonMidpoint = settings.dropShadow.size;
                        else if (polygonMidpoint > dimensions.textBox.width + settings.dropShadow.size)
                            polygonMidpoint = dimensions.textBox.width + settings.dropShadow.size;

                        notchPolygonPoints += polygonMidpoint.toString() + "," + (textBoxPositionWithNotch.y + dimensions.textBox.height + settings.notchSize).toString();
                        if (polygonMidpoint < settings.dropShadow.size + (settings.notchSize + settings.outline.radius)) {
                            // Clipped on the left
                            notchPolygonPoints += " " + polygonMidpoint.toString() + "," + (textBoxPositionWithNotch.y + dimensions.textBox.height - settings.outline.radius).toString();
                            notchPolygonPoints += " " + (polygonMidpoint + settings.notchSize).toString() + "," + (textBoxPositionWithNotch.y + dimensions.textBox.height - settings.outline.radius).toString();
                            notchPolygonPoints += " " + (polygonMidpoint + settings.notchSize).toString() + "," + (textBoxPositionWithNotch.y + dimensions.textBox.height).toString();
                        } else if (polygonMidpoint > dimensions.textBox.width + settings.dropShadow.size - (settings.notchSize + settings.outline.radius)) {
                            // Clipped on the right
                            notchPolygonPoints += " " + polygonMidpoint.toString() + "," + (textBoxPositionWithNotch.y + dimensions.textBox.height - settings.outline.radius).toString();
                            notchPolygonPoints += " " + (polygonMidpoint - settings.notchSize).toString() + "," + (textBoxPositionWithNotch.y + dimensions.textBox.height - settings.outline.radius).toString();
                            notchPolygonPoints += " " + (polygonMidpoint - settings.notchSize).toString() + "," + (textBoxPositionWithNotch.y + dimensions.textBox.height).toString();
                        } else {
                            // Show full polygon
                            notchPolygonPoints += " " + (polygonMidpoint + settings.notchSize).toString() + "," + (textBoxPositionWithNotch.y + dimensions.textBox.height).toString();
                            notchPolygonPoints += " " + (polygonMidpoint + settings.notchSize).toString() + "," + (textBoxPositionWithNotch.y + dimensions.textBox.height - 1).toString();
                            notchPolygonPoints += " " + (polygonMidpoint - settings.notchSize).toString() + "," + (textBoxPositionWithNotch.y + dimensions.textBox.height - 1).toString();
                            notchPolygonPoints += " " + (polygonMidpoint - settings.notchSize).toString() + "," + (textBoxPositionWithNotch.y + dimensions.textBox.height).toString();
                        }

                        // Set container positioning class
                        t.container.classList.add(settings.classNames.positioningTypeAbove);
                        break;

                    case positioningTypes.below:
                        var polygonMidpoint = ((tooltipSizeWithNotch.width - settings.dropShadow.xOffset) / 2) + notchPositioningOffset;
                        if (polygonMidpoint < settings.dropShadow.size)
                            polygonMidpoint = settings.dropShadow.size;
                        else if (polygonMidpoint > dimensions.textBox.width + settings.dropShadow.size)
                            polygonMidpoint = dimensions.textBox.width + settings.dropShadow.size;

                        notchPolygonPoints += polygonMidpoint.toString() + "," + (textBoxPositionWithNotch.y - settings.notchSize).toString();
                        if (polygonMidpoint < settings.dropShadow.size + (settings.notchSize + settings.outline.radius)) {
                            // Clipped on the left
                            notchPolygonPoints += " " + polygonMidpoint.toString() + "," + (textBoxPositionWithNotch.y + settings.outline.radius).toString();
                            notchPolygonPoints += " " + (polygonMidpoint + settings.notchSize).toString() + "," + (textBoxPositionWithNotch.y + settings.outline.radius).toString();
                            notchPolygonPoints += " " + (polygonMidpoint + settings.notchSize).toString() + "," + (textBoxPositionWithNotch.y).toString();
                        } else if (polygonMidpoint > dimensions.textBox.width + settings.dropShadow.size - (settings.notchSize + settings.outline.radius)) {
                            // Clipped on the right
                            notchPolygonPoints += " " + polygonMidpoint.toString() + "," + (textBoxPositionWithNotch.y + settings.outline.radius).toString();
                            notchPolygonPoints += " " + (polygonMidpoint - settings.notchSize).toString() + "," + (textBoxPositionWithNotch.y + settings.outline.radius).toString();
                            notchPolygonPoints += " " + (polygonMidpoint - settings.notchSize).toString() + "," + (textBoxPositionWithNotch.y).toString();
                        } else {
                            // Show full polygon
                            notchPolygonPoints += " " + (polygonMidpoint + settings.notchSize).toString() + "," + (textBoxPositionWithNotch.y).toString();
                            notchPolygonPoints += " " + (polygonMidpoint + settings.notchSize).toString() + "," + (textBoxPositionWithNotch.y + 1).toString();
                            notchPolygonPoints += " " + (polygonMidpoint - settings.notchSize).toString() + "," + (textBoxPositionWithNotch.y + 1).toString();
                            notchPolygonPoints += " " + (polygonMidpoint - settings.notchSize).toString() + "," + (textBoxPositionWithNotch.y).toString();
                        }

                        // Set container positioning class
                        t.container.classList.add(settings.classNames.positioningTypeBelow);
                        break;

                    case positioningTypes.left:
                        var polygonMidpoint = ((tooltipSizeWithNotch.height - settings.dropShadow.yOffset) / 2) + notchPositioningOffset;
                        if (polygonMidpoint < settings.dropShadow.size)
                            polygonMidpoint = settings.dropShadow.size;
                        else if (polygonMidpoint > dimensions.textBox.height + settings.dropShadow.size)
                            polygonMidpoint = dimensions.textBox.height + settings.dropShadow.size;

                        notchPolygonPoints += (textBoxPositionWithNotch.x + dimensions.textBox.width + settings.notchSize).toString() + "," + polygonMidpoint.toString();
                        if (polygonMidpoint < settings.dropShadow.size + (settings.notchSize + settings.outline.radius)) {
                            // Clipped above
                            notchPolygonPoints += " " + (textBoxPositionWithNotch.x + dimensions.textBox.width - settings.outline.radius).toString() + "," + polygonMidpoint.toString();
                            notchPolygonPoints += " " + (textBoxPositionWithNotch.x + dimensions.textBox.width - settings.outline.radius).toString() + "," + (polygonMidpoint + settings.notchSize).toString();
                            notchPolygonPoints += " " + (textBoxPositionWithNotch.x + dimensions.textBox.width).toString() + "," + (polygonMidpoint + settings.notchSize).toString();
                        } else if (polygonMidpoint > dimensions.textBox.height + settings.dropShadow.size - (settings.notchSize + settings.outline.radius)) {
                            // Clipped below
                            notchPolygonPoints += " " + (textBoxPositionWithNotch.x + dimensions.textBox.width - settings.outline.radius).toString() + "," + polygonMidpoint.toString();
                            notchPolygonPoints += " " + (textBoxPositionWithNotch.x + dimensions.textBox.width - settings.outline.radius).toString() + "," + (polygonMidpoint - settings.notchSize).toString();
                            notchPolygonPoints += " " + (textBoxPositionWithNotch.x + dimensions.textBox.width).toString() + "," + (polygonMidpoint - settings.notchSize).toString();
                        } else {
                            // Show full polygon
                            notchPolygonPoints += " " + (textBoxPositionWithNotch.x + dimensions.textBox.width).toString() + "," + (polygonMidpoint + settings.notchSize).toString();
                            notchPolygonPoints += " " + (textBoxPositionWithNotch.x + dimensions.textBox.width - 1).toString() + "," + (polygonMidpoint + settings.notchSize).toString();
                            notchPolygonPoints += " " + (textBoxPositionWithNotch.x + dimensions.textBox.width - 1).toString() + "," + (polygonMidpoint - settings.notchSize).toString();
                            notchPolygonPoints += " " + (textBoxPositionWithNotch.x + dimensions.textBox.width).toString() + "," + (polygonMidpoint - settings.notchSize).toString();
                        }

                        // Set container positioning class
                        t.container.classList.add(settings.classNames.positioningTypeLeft);
                        break;

                    case positioningTypes.right:
                        var polygonMidpoint = ((tooltipSizeWithNotch.height - settings.dropShadow.yOffset) / 2) + notchPositioningOffset;
                        if (polygonMidpoint < settings.dropShadow.size)
                            polygonMidpoint = settings.dropShadow.size;
                        else if (polygonMidpoint > dimensions.textBox.height + settings.dropShadow.size)
                            polygonMidpoint = dimensions.textBox.height + settings.dropShadow.size;

                        notchPolygonPoints += (textBoxPositionWithNotch.x - settings.notchSize).toString() + "," + polygonMidpoint.toString();
                        if (polygonMidpoint < settings.dropShadow.size + (settings.notchSize + settings.outline.radius)) {
                            // Clipped above
                            notchPolygonPoints += " " + (textBoxPositionWithNotch.x + settings.outline.radius).toString() + "," + polygonMidpoint.toString();
                            notchPolygonPoints += " " + (textBoxPositionWithNotch.x + settings.outline.radius).toString() + "," + (polygonMidpoint + settings.notchSize).toString();
                            notchPolygonPoints += " " + (textBoxPositionWithNotch.x).toString() + "," + (polygonMidpoint + settings.notchSize).toString();
                        } else if (polygonMidpoint > dimensions.textBox.height + settings.dropShadow.size - (settings.notchSize + settings.outline.radius)) {
                            // Clipped below
                            notchPolygonPoints += " " + (textBoxPositionWithNotch.x + settings.outline.radius).toString() + "," + polygonMidpoint.toString();
                            notchPolygonPoints += " " + (textBoxPositionWithNotch.x + settings.outline.radius).toString() + "," + (polygonMidpoint - settings.notchSize).toString();
                            notchPolygonPoints += " " + (textBoxPositionWithNotch.x).toString() + "," + (polygonMidpoint - settings.notchSize).toString();
                        } else {
                            // Show full polygon
                            notchPolygonPoints += " " + (textBoxPositionWithNotch.x).toString() + "," + (polygonMidpoint + settings.notchSize).toString();
                            notchPolygonPoints += " " + (textBoxPositionWithNotch.x + 1).toString() + "," + (polygonMidpoint + settings.notchSize).toString();
                            notchPolygonPoints += " " + (textBoxPositionWithNotch.x + 1).toString() + "," + (polygonMidpoint - settings.notchSize).toString();
                            notchPolygonPoints += " " + (textBoxPositionWithNotch.x).toString() + "," + (polygonMidpoint - settings.notchSize).toString();
                        }

                        // Set container positioning class
                        t.container.classList.add(settings.classNames.positioningTypeRight);
                        break;
                }

                polygonNode.setAttribute("points", notchPolygonPoints);

                // Stop any ongoing animation
                if (timeline)
                    timeline.progress(1);

                timeline = new TimelineLite();
                timeline.fromTo(
                    t.container,
                    event.shiftKey === true ? settings.revealDuration * settings.slowMoScale : settings.revealDuration,
                    {
                        opacity: 0
                    },
                    {
                        ease: Power4.easeOut,
                        opacity: 1,
                        display: "block",
                        onUpdate: function () {
                            var percentComplete = t.container.style.opacity,
                                reversePercentComplete = 1 - percentComplete,
                                offset = reversePercentComplete * settings.notchSize;

                            switch (positioningType) {
                                case positioningTypes.above:
                                    offset = Math.round(offset * 1000) / 1000;
                                    backdropNode.parentNode.setAttribute("transform", `translate(0, ${offset})`);
                                    t.content.style.transform = `translate(0px, ${numberToPx(offset)})`;

                                    offset = reversePercentComplete * settings.revealDistance;
                                    offset = -Math.round(offset * 1000) / 1000;
                                    t.container.style.transform = `translate(0px, ${numberToPx(offset)})`;
                                    break;

                                case positioningTypes.below:
                                    offset = -Math.round(offset * 1000) / 1000;
                                    backdropNode.parentNode.setAttribute("transform", `translate(0, ${offset})`);
                                    t.content.style.transform = `translate(0px, ${numberToPx(offset)})`;

                                    offset = reversePercentComplete * settings.revealDistance;
                                    offset = Math.round(offset * 1000) / 1000;
                                    t.container.style.transform = `translate(0px, ${numberToPx(offset)})`;
                                    break;

                                case positioningTypes.left:
                                    offset = Math.round(offset * 1000) / 1000;
                                    backdropNode.parentNode.setAttribute("transform", `translate(${offset}, 0)`);
                                    t.content.style.transform = `translate(${numberToPx(offset)}, 0px)`;

                                    offset = reversePercentComplete * settings.revealDistance;
                                    offset = -Math.round(offset * 1000) / 1000;
                                    t.container.style.transform = `translate(${numberToPx(offset)}, 0px)`;
                                    break;

                                case positioningTypes.right:
                                    offset = -Math.round(offset * 1000) / 1000;
                                    backdropNode.parentNode.setAttribute("transform", `translate(${offset}, 0)`);
                                    t.content.style.transform = `translate(${numberToPx(offset)}, 0px)`;

                                    offset = reversePercentComplete * settings.revealDistance;
                                    offset = Math.round(offset * 1000) / 1000;
                                    t.container.style.transform = `translate(${numberToPx(offset)}, 0px)`;
                                    break;
                            }
                        },
                        onComplete: function () {
                            timeline = null;
                        }
                    });
            },

            hideCallback = function (event) {
                t.container.style.display = "block";

                if (timeline)
                    timeline.progress(1);

                timeline = new TimelineLite();
                timeline.fromTo(
                    t.container,
                    event.shiftKey === true ? settings.hideDuration * settings.slowMoScale : settings.hideDuration,
                    {
                        opacity: 1
                    },
                    {
                        ease: Power2.easeOut,
                        opacity: 0,
                        display: "none",
                        onComplete: function () {
                            t.visible = false;
                            timeline = null;
                        }
                    });
            };

        // Install rollover events
        hoverElement.addEventListener("mouseenter", revealCallback);
        hoverElement.addEventListener("mouseleave", hideCallback);

        hoverElement.addEventListener("touchstart", function (event) {
            if (t.visible)
                return;

            revealCallback(event);

            // Only perform the hide callback once
            var touchHideCallback = function (event) {
                document.removeEventListener("scroll", touchHideCallback);
                document.removeEventListener("resize", touchHideCallback);
                document.removeEventListener("touchstart", touchHideCallback);

                hideCallback(event);
            };

            setTimeout(
                function () {
                    document.addEventListener("scroll", touchHideCallback);
                    document.addEventListener("resize", touchHideCallback);
                    document.addEventListener("touchstart", touchHideCallback);
                },
                100);
        });
    }

    removeFromDom() {
        var t = this;

        t.container.remove();
    }

    static get positioningTypes() {
        return positioningTypes;
    }
}



// WEBPACK FOOTER //
// ./Scripts/libraries/tooltip.js